import React from 'react'
import Svg from '../../../../../shared/Svg'

export default props => (
  <Svg {...props} width="30px" height="15px" viewBox="0 0 30 15">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-177.000000, -725.000000)" fill="#4A4A4A" fillRule="nonzero">
        <g transform="translate(0.000000, 141.000000)">
          <g transform="translate(49.000000, 524.000000)">
            <g transform="translate(103.000000, 34.000000)">
              <path d="M52.2368421,40.6052632 C53.7602816,40.6052632 55,39.3657342 55,37.8421053 L55,26 L25,26 L25,37.8421053 C25,39.3657342 26.2397184,40.6052632 27.7631579,40.6052632 L52.2368421,40.6052632 Z M26.5789474,27.5789474 L53.4210526,27.5789474 L53.4210526,32.7105263 L26.5789474,32.7105263 L26.5789474,27.5789474 Z M26.5789474,37.8421053 L26.5789474,34.2894737 L53.4210526,34.2894737 L53.4210526,37.8421053 C53.4210526,38.4951184 52.8898553,39.0263158 52.2368421,39.0263158 L27.7631579,39.0263158 C27.1101447,39.0263158 26.5789474,38.4951184 26.5789474,37.8421053 Z M28.9473684,29.9473684 L30.5263158,29.9473684 L30.5263158,31.5263158 L28.9473684,31.5263158 L28.9473684,29.9473684 Z M32.1052632,29.9473684 L33.6842105,29.9473684 L33.6842105,31.5263158 L32.1052632,31.5263158 L32.1052632,29.9473684 Z M28.5526316,35.8684211 L51.4473684,35.8684211 L51.4473684,37.4473684 L28.5526316,37.4473684 L28.5526316,35.8684211 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)
